import React, { Fragment, Suspense } from 'react';
import PropTypes from 'prop-types';
import { useForceUpdateOnWindowResize } from '@zola/zola-ui/src/hooks/useForceUpdateOnWindowResize';
import { notDesktop } from '@zola-helpers/client/dist/es/util/responsive';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import renderOrganizationJsonLdScript from '../orgSchema';

import '../../../stylesheets/nav/WebsiteNav.less';

const NavV2 = React.lazy(() => import(/* webpackChunkName: "desktop-nav" */ 'components/navV2'));

const WhichMobileNavToRender = React.lazy(() =>
  import(/* webpackChunkName: "mobile-nav" */ 'components/WhichMobileNavToRender')
);

const {
  EVENTS: { MODAL_TYPE_AUTH },
} = NAV_DATA;

const NavContainer = ({ openModal }) => {
  useForceUpdateOnWindowResize();

  // Allow web-apps to open authModal:
  window.zolaNav = window.zolaNav || {};
  const openAuthModal = (opts, authState) => {
    let loginCallback;
    let signupCallback;
    let signupLinkCallback;
    let closeCallback;

    if (typeof opts === 'function') {
      loginCallback = opts;
    } else if (typeof opts === 'object') {
      loginCallback = opts.loginCallback; // eslint-disable-line
      signupCallback = opts.signupCallback; // eslint-disable-line
      signupLinkCallback = opts.signupLinkCallback; // eslint-disable-line
      closeCallback = opts.closeCallback; // eslint-disable-line
    }
    const ariaLabel = authState === 'login' ? 'Log In' : 'Sign Up';

    return openModal(
      MODAL_TYPE_AUTH,
      { authState, loginCallback, signupCallback, signupLinkCallback, closeCallback },
      { size: 'sm', ariaLabel }
    );
  };
  window.zolaNav.openLoginModal = (opts) => openAuthModal(opts, 'login');
  window.zolaNav.openSignupModal = (opts) => openAuthModal(opts, 'signup');

  const Nav = notDesktop() ? WhichMobileNavToRender : NavV2;

  return (
    <Fragment>
      <Suspense fallback={<div />}>
        <Nav />
      </Suspense>
      {renderOrganizationJsonLdScript()}
    </Fragment>
  );
};

export default NavContainer;

NavContainer.propTypes = {
  openModal: PropTypes.func,
  userContext: PropTypes.shape({}),
};
